<h3 class="shop-settings__form-title">{{ 'shop-settings.general.subtitle' | translate }}</h3>
<form class="shop-settings__form" [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="shop-settings__inputs">
    <div class="shop-settings__input-wrapper">
      <mat-label>{{ 'shop-settings.general.shopInfo.shopName' | translate }}</mat-label>
      <mat-form-field appearance="outline">
        <input
          matInput
          formControlName="name"
          [placeholder]="'shop-settings.general.placeholders.shopName' | translate"
        />
        <mat-error>
          {{ tryGetFirstError('name') | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="shop-settings__input-wrapper">
      <mat-label>{{ 'shop-settings.general.shopInfo.email' | translate }}</mat-label>
      <mat-form-field appearance="outline">
        <input
          matInput
          formControlName="email"
          [placeholder]="'shop-settings.general.placeholders.email' | translate"
        />
        <mat-error>
          {{ tryGetFirstError('email') | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <app-phone-number-form-field
      [country]="selectedCountry()"
      [control]="getFormControl('phoneNumber')"
      [labelText]="'shop-settings.general.shopInfo.phoneNumber'"
      (countryChanged)="updatePlaceholders($event)"
      [phoneMaskOptions]="phoneMaskOptions()"
      [errorDescriptions]="PHONE_ERRORS_KEYS_MAP"
    />

    <div class="shop-settings__input-wrapper">
      <mat-label>{{ 'shop-settings.general.shopInfo.url' | translate }}</mat-label>
      <mat-form-field appearance="outline">
        <input
          matInput
          formControlName="url"
          [placeholder]="'shop-settings.general.placeholders.url' | translate"
        />
        <mat-error>
          {{ tryGetFirstError('url') | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="shop-settings__input-wrapper">
      <mat-label>{{ 'shop-settings.general.shopInfo.shopAddress' | translate }}</mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="address" />
        <mat-error>
          {{ tryGetFirstError('address') | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="shop-settings__input-wrapper">
      <mat-label>{{ 'shop-settings.general.shopInfo.country' | translate }}</mat-label>
      <mat-form-field appearance="outline">
        <mat-select
          formControlName="countryId"
          (selectionChange)="countrySelectionChange($event)"
          [value]="selectedCountry()?.name"
        >
          <mat-select-trigger class="shop-settings__selectedWrapper">
            <div class="shop-settings__selectedCountry">{{ selectedCountry()?.name }}</div>
          </mat-select-trigger>
          @for (country of countries(); track $index) {
            <mat-option [value]="country.name">
              {{ country.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="shop-settings__input-wrapper">
      <mat-label>{{ 'shop-settings.general.shopInfo.city' | translate }}</mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="city" />
        <mat-error>
          {{ tryGetFirstError('city') | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="shop-settings__input-wrapper">
      <mat-label>{{ 'shop-settings.general.shopInfo.state' | translate }}</mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="state" />
        <mat-error>
          {{ tryGetFirstError('state') | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="shop-settings__input-wrapper">
      <mat-label>{{ 'shop-settings.general.shopInfo.zipCode' | translate }}</mat-label>
      <mat-form-field appearance="outline">
        <input
          matInput
          formControlName="zipCode"
          [mask]="zipMaskOptions().mask"
          [prefix]="zipMaskOptions().prefix ?? ''"
          [validation]="zipMaskOptions().isValidationOn"
          [inputTransformFn]="transformZipTextToUppercase"
        />
        <mat-error>
          {{ tryGetFirstError('zipCode') | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="shop-settings__input-wrapper description">
      <mat-label>{{ 'shop-settings.general.shopInfo.description' | translate }}</mat-label>
      <mat-form-field appearance="outline">
        <textarea
          class="shop-settings__description-input"
          matInput
          formControlName="description"
          [placeholder]="'shop-settings.general.placeholders.description' | translate"
        ></textarea>
        <mat-error>
          {{ tryGetFirstError('description') | translate }}
        </mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="shop-settings__btn-wrapper">
    <button type="button" class="btn-white" (click)="cancelDataChange()">
      {{ 'shop-settings.general.buttons.cancel' | translate }}
    </button>

    <button type="submit" class="btn-primary">
      {{ 'shop-settings.general.buttons.save' | translate }}
    </button>
  </div>
</form>
